import { useQuery, useQueryClient } from "@tanstack/react-query";

import { recentSearchesQuery } from "#modules/search/infra/recentSearches.query";
import { SEARCH_PAGE_SIZE } from "#modules/search/infra/search.api";
import { searchResultsQuery } from "#modules/search/infra/search.query";
import { SearchEntity } from "shared";

type UseSearchPageQueriesParams = {
  query: string;
  entity?: SearchEntity;
  page: number;
};

export const useSearchPageQueries = ({ query, entity, page }: UseSearchPageQueriesParams) => {
  const queryClient = useQueryClient();
  const hasSubmittedQuery = query.length > 0;
  const searchOptions = searchResultsQuery({ query, entity, page });

  const searchQuery = useQuery({
    ...searchOptions,
    queryFn: async () => {
      const results = await searchOptions.queryFn();
      void queryClient.invalidateQueries(recentSearchesQuery());
      return results;
    },
  });

  const recentQuery = useQuery({
    ...recentSearchesQuery(),
    enabled: !hasSubmittedQuery,
  });

  const pageCount = searchQuery.data ? Math.ceil(searchQuery.data.total / SEARCH_PAGE_SIZE) : 0;

  return {
    results: searchQuery.data,
    isSearchError: searchQuery.isError,
    recentSearches: recentQuery.data ?? [],
    pageCount,
  };
};
